"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 15h14V9H5v6zm2-4h10v2H7v-2zM11 1h2v3h-2zM20.46 5.01L19.04 3.6l-1.79 1.79 1.41 1.41zM11 20h2v3h-2zM17.24 18.71l1.79 1.8 1.42-1.42-1.8-1.79zM4.9592 3.5949l1.789 1.789-1.4071 1.407L3.552 5.002zM3.55 19.08l1.41 1.42 1.79-1.8-1.41-1.41z"
}))), 'WbIridescentOutlined');

exports.default = _default;